module.exports = __webpack_public_path__ + "34d78e85ddbdcfc0a41967980b022905.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/paywalls/text-specific-questions.png
// module id = 2728
// module chunks = 0